import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=276baf3f&scoped=true&"
import script from "./DashboardLayout.vue?vue&type=script&lang=ts&"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=276baf3f&prod&lang=scss&"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=276baf3f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276baf3f",
  null
  
)

export default component.exports